import { AppState } from 'store/store';
import { starReportSlice } from 'store/star-report/star-report-slice';

export const starReportReducer = {
    starReport: starReportSlice.reducer,
};

export type StarReportState2 = AppState;
